import React, {useContext, useState, useEffect} from 'react';
import { useTheme, Typography, makeStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Helpers from '../../../global/helpers';

import AutoTable from '../../../../components/autoTable';
import globalContext from '../../../../context/global-context';
const useStyles = makeStyles(theme => ({
    container: {
        display: 'block',
        width: '100%',
        maxHeight: 300,
        overflowY: 'auto'
    },
    inner: {},
}));

const AppUserRecentChargepoints = props => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const context = useContext(globalContext);

    const {id_user} = props;

    const headCells = ["cpid", "serial_number", "unit_type", "created", "status"]
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    const loadData = async search => {
        setLoading(true);
        setError(null);
        setData([]);

        try {
            
            const res = await context.apiRequest(`/service_consumer/ev_connect/app_user/recent_chargepoints?id=${id_user}`, 'GET');
            if(res.success)
                setData(res.result);
            else
                throw res.msg;
            
        } catch (err) {

            setError(typeof err === 'string' ? err : typeof err?.msg === 'string' ? err.msg : JSON.stringify(err));
            setData([]);
            
        } finally {
            setLoading(false);
        }
        
    }

    useEffect(() => {
        loadData();
    }, [])

    return (
        <React.Fragment>
            <div className={classes.container}>
                <div className={classes.inner}>

                    {error && <Alert severity="error">{error}</Alert>}

                    <AutoTable 
                        rows={data} 
                        idCol="id"
                        headCells={headCells}
                        loading={loading}
                        cellReplacementProps={{
                            'created': (val, id) => Helpers.toLocaleDateTime(val)
                        }}
                    />

                </div>
            </div>
        </React.Fragment>
    )
}
export default AppUserRecentChargepoints;